import { Autocomplete, Grid, IconButton, InputAdornment, TextField, Toolbar } from '@mui/material';

import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from '../utils';
import { cv } from '../themeVars';


export const TemplatedMessagesMenuToolbar = (props) => {
    const searchQueryRef = React.useRef(null);

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        console.log("TemplatedMessagesMenuToolbar: Searching:", searchQueryRef.current?.value)
        doSearch(searchQueryRef.current?.value);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    const handleLanguageSelectChange = (event, lang, reason) => {
        console.log('lang change', lang);
        props.setSelectedLanguageFilter(lang)
        if (lang === null) {
            props.setAPIFilters(props.apiFilters.filter(function(item){ return item.field !== 'language'}));
        } else {
            props.setAPIFilters([
                ...props.apiFilters.filter(function(item){ return item.field !== 'language'}),
                { field: 'language', op: 'equals', value: lang?.id?.toUpperCase()},
            ]);
        }
    };

    const handleTopicSelectChange = (event, topic, reason) => {
        console.log('topic change', topic);
        props.setSelectedTopicFilter(topic)
        if (topic === null) {
            props.setAPIFilters(props.apiFilters.filter(function(item){ return item.field !== 'topic'}));
        } else {
            const dict = topic != "No topic assigned" ? { field: 'topic', op: 'equals', value: topic } : { field: 'topic', op: 'null'}
            props.setAPIFilters([
                ...props.apiFilters.filter(function(item){ return item.field !== 'topic'}),
                dict,
            ]);
            console.log('topic change', props.apiFilters);
        }
    };

    console.log('TemplatedMessagesMenuToolbar', props);

    React.useEffect(() => {
        if(props.subjectUserLanguage && props.languages){
            handleLanguageSelectChange(null, props.languages.find((element) => element.id?.toUpperCase() === props.subjectUserLanguage?.toUpperCase()))
        }
    }, [props.languages]);

    return (
        <Toolbar disableGutters={true} style={{}}>
            <Grid container direction="column">
                <Grid item xs={12} sm={4} style={{paddingLeft: "10px", paddingRight: "10px"}}>
                    <TextField
                        variant="filled"
                        label="Search"
                        size="small"
                        onChange={debouncedSearchQueryChangeHandler}
                        inputRef={searchQueryRef}
                        defaultValue={props.query}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid container direction="row">
                    <Grid item xs={12} sm={7} style={{ padding: "10px" }}>
                        <Autocomplete
                            onChange={handleTopicSelectChange}
                            value={props.selectedTopicFilter}
                            options={props.topicOptions?.map((option) => option.name)}
                            renderInput={(params) => <TextField {...params} variant="filled" size="small" fullWidth label="Topic" />}
                        />
                        <span
                            style={{ cursor: "pointer", fontSize: ".8rem", color: cv('accent', "#007AFF") }}
                            onClick={(e) => {
                                e.stopPropagation();
                                props.setIsViewingTopics(true);
                            }}>View all topics
                        </span>

                    </Grid>
                    <Grid item xs={12} sm={5} style={{ padding: "10px"}}>
                        <Autocomplete
                            options={props.languages}
                            getOptionLabel={(opt) => opt.name ?? opt}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Language"
                                    variant="filled"
                                    size="small"
                                />
                            )}
                            fullWidth
                            onChange={handleLanguageSelectChange}
                            value={props.selectedLanguageFilter }
                        />
                    </Grid>
                </Grid>

            </Grid>
        </Toolbar>
    );
};

export default TemplatedMessagesMenuToolbar;
